import { useEffect, useState } from 'react';
import { api } from '../../services/api';

/** Authenticated image loader for private backend images (Bearer cannot be sent by img). */
export default function AuthImage({ url, alt, className, onClick, onSrc }: {
  url?: string; alt: string; className?: string; onClick?: () => void;
  /** Optional: reports the resolved object URL (or undefined on error/cleanup) so parents can open a lightbox with the authenticated blob. */
  onSrc?: (src: string | undefined) => void;
}) {
  const [src, setSrc] = useState<string>();
  useEffect(() => {
    let active = true;
    let objectUrl: string | undefined;
    if (!url) return () => { active = false; };
    const path = url.startsWith('/api/') ? url.slice(4) : url;
    api.get(path, { responseType: 'blob' }).then((res) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(res.data);
      setSrc(objectUrl);
      onSrc?.(objectUrl);
    }).catch(() => { if (active) setSrc(undefined); });
    return () => { active = false; onSrc?.(undefined); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url]);
  if (!src) return <div className={className || 'bg-gray-700'} aria-label={alt} />;
  return <img src={src} alt={alt} className={className} onClick={onClick} />;
}
